// for upload

const requiredTags = [
  "SOPInstanceUIDOfConcatenationSource",
  "ConcatenationUID",
  "InConcatenationNumber",
  "ConcatenationFrameOffsetNumber",
  "NumberOfFrames",
  "SpectrallySelectedSuppression",

  // "SharedFunctionalGroupsSequence",
  // "PerFrameFunctionalGroupsSequence",

  "ImageType",
  "SOPClassUID",
  "SOPInstanceUID",
  "StudyDate",
  "StudyTime",
  "AccessionNumber",
  "Modality",
  "ReferringPhysicianName",
  // "StudyDescription",
  "SeriesDescription",
  "PatientName",
  "PatientID",
  "PatientBirthDate",
  "PatientSex",
  "PlanarConfiguration", // ***********
  "ScanningSequence",
  "SequenceVariant",
  "ScanOptions",
  "MRAcquisitionType",
  "SliceThickness",
  "RepetitionTime",
  "EchoTime",
  // "ImagingFrequency",
  "MagneticFieldStrength",
  "EchoTrainLength",
  "PatientPosition",
  "StudyInstanceUID",
  "SeriesInstanceUID",
  "StudyID", // ***********
  "SeriesNumber",
  // "AcquisitionNumber",
  "InstanceNumber",
  "ImagePositionPatient",
  "ImageOrientationPatient",
  "FrameOfReferenceUID",
  "Laterality",
  "PositionReferenceIndicator",
  // "SliceLocation",
  "SamplesPerPixel",
  "PhotometricInterpretation",
  "Rows",
  "Columns",
  "PixelSpacing",
  "BitsAllocated",
  "BitsStored",
  "HighBit",
  "PixelRepresentation",
  "SmallestImagePixelValue",
  "LargestImagePixelValue",
  "WindowCenter",
  "WindowWidth"
];

/* const requiredTags = [
  'BitsAllocated',
  'BitsStored',
  'Columns',
  'EchoTime',
  'FrameOfReferenceUID',
  'HighBit',
  'ImageOrientationPatient',
  'ImagePositionPatient',
  'LargestImagePixelValue',
  'PixelSpacing',
  'RepetitionTime',
  'Rows',
  'ScanOptions',
  'SeriesInstanceUID',
  'SliceThickness',
  'SmallestImagePixelValue',
  'SOPInstanceUID',
  'StudyInstanceUID',

  'MagneticFieldStrength',
  'Modality',
  'Manufacturer',
  'StudyDescription',
  'StudyDate',
  'SeriesDate',
  'SeriesDescription',
  'ManufacturerModelName',
  'BodyPartExamined',
  'ScanningSequence',
  'SequenceVariant',
  'MRAcquisitionType',
  'SequenceName',
  'NumberOfAverages',
  'ImagingFrequency',
  'ImagedNucleus',
  'ImageType',
  'SpacingBetweenSlices',
  'ProtocolName',
  'PatientPosition',
  'PhotometricInterpretation',
  'PixelRepresentation',
  'Laterality',
  'WindowCenter',
  'WindowWidth',
  'SOPClassUID',
  'PatientID',
  'PatientSex',
  'PatientAge',
  'PatientWeight',
  'EchoNumbers',
  'SeriesNumber',
  'AcquisitionNumber',
  'InstanceNumber'

]; */

module.exports = { requiredTags };
